import { render } from "./BenchmarkManager.vue?vue&type=template&id=73a9885e"
import script from "./BenchmarkManager.vue?vue&type=script&lang=js"
export * from "./BenchmarkManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__